import {
  post,
  putPrimary,
  get,
  getTimeline,
  put,
  remove,
  verify,
} from "src/api/bank";
import AddBankForm from "src/modules/user/components/AddBankForm.vue";
import ViewBankTimelinesDrawer from "src/modules/user/components/ViewBankTimelinesDrawer.vue";
const getInitialState = () => {
  return {
    timelines: [],
    banks: [],
  };
};
export const useBankStore = defineStore("bank", () => {
  const { user } = storeToRefs(useUserStore());
  const { state: addBankFormState, toggle: toggleAddBankForm } = useDrawer({
    component: AddBankForm,
  });

  const { toggle: toggleBankTimelinesDrawer } = useDrawer({
    component: ViewBankTimelinesDrawer,
  });

  let state = reactive(getInitialState());

  const postBank = async (payload) => {
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = await post(unref(user)._id, payload, options);

    getBanks();

    return response;
  };

  const putBank = async (payload) => {
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = await putPrimary(unref(user)._id, payload, options);

    return response;
  };

  const resetBankState = () => {
    state.banks = [];
  };

  const getBanks = async () => {
    const response = await get(unref(user)._id);

    if (response?.data?.data?.length) {
      const sortedData = response.data.data.sort((a, b) => {
        return b.is_primary - a.is_primary;
      });

      state.banks = sortedData;
    } else {
      state.banks = [];
    }

    return response;
  };

  const getTimelines = async () => {
    const response = await getTimeline(unref(user)._id);

    state.timelines = response?.data?.data?.data || [];

    return response;
  };

  const removeBank = async (payload) => {
    const response = await remove(unref(user)._id, payload);

    getBanks();

    return response;
  };

  const editBank = async (payload) => {
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = await put(unref(user)._id, payload, options);

    getBanks();

    return response;
  };

  const verifyBank = async (payload) => {
    const response = await verify(unref(user)._id, payload);

    getBanks();

    return response;
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    ...toRefs(state),
    addBankFormState,
    toggleAddBankForm,
    toggleBankTimelinesDrawer,
    verifyBank,
    getBanks,
    editBank,
    removeBank,
    getTimelines,
    putBank,
    postBank,
    resetBankState,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBankStore, import.meta.hot));
}
